import { mainSiteUrl } from '@/mocks/categories';

const seoArticles = [
  {
    title: 'Kakobuy Spreadsheet 2026: The Ultimate Product Discovery Guide',
    desc: 'Comprehensive walkthrough covering beginner basics to advanced product research strategies, QC photo analysis, and category navigation for smarter shopping.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20modern%20workspace%20desk%20with%20laptop%20displaying%20colorful%20spreadsheet%20interface%20surrounded%20by%20curated%20fashion%20accessories%20shopping%20catalogs%20and%20product%20samples%20on%20warm%20cream%20surface%20natural%20window%20lighting%20editorial%20composition&width=800&height=500&seq=seo-article-01&orientation=landscape',
    link: '/kakobuy-spreadsheet-guide',
  },
  {
    title: 'Vigorbuy Spreadsheet: Your Complete Shopping Research Database',
    desc: 'Everything about the Vigorbuy Spreadsheet ecosystem &mdash; daily updates, 14 curated categories, QC integration, and strategies for finding the best products faster.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20retail%20product%20display%20arrangement%20with%20various%20fashion%20items%20clothing%20accessories%20and%20lifestyle%20goods%20arranged%20neatly%20on%20light%20beige%20surface%20with%20soft%20diffused%20natural%20light%20modern%20catalog%20photography%20aesthetic%20clean%20composition&width=800&height=500&seq=seo-article-02&orientation=landscape',
    link: '/vigorbuy-spreadsheet',
  },
  {
    title: 'QC Spreadsheet Guide: How to Read Quality Check Photos',
    desc: 'Master the five-point QC checklist for evaluating product quality. Learn to spot material quality, stitching details, color accuracy, and hidden defects before buying.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20macro%20detail%20shot%20of%20fabric%20texture%20examination%20with%20magnifying%20glass%20over%20textile%20swatches%20on%20clean%20white%20inspection%20table%20with%20measurement%20tools%20and%20quality%20control%20checklist%20soft%20bright%20commercial%20studio%20lighting&width=800&height=500&seq=seo-article-03&orientation=landscape',
    link: '/qc-spreadsheet-guide',
  },
  {
    title: 'Shopping Safety Guide: Secure Spreadsheet Product Discovery',
    desc: 'Protect your privacy and shop with confidence. Covers payment security, data protection, smart purchasing strategies, and what to do when issues arise.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20security%20concept%20with%20shield%20icon%20and%20padlock%20symbol%20floating%20above%20ecommerce%20shopping%20interface%20on%20tablet%20screen%20clean%20cream%20desk%20background%20soft%20ambient%20lighting%20trust%20and%20safety%20imagery%20professional%20style&width=800&height=500&seq=seo-article-04&orientation=landscape',
    link: '/shopping-safety-guide',
  },
  {
    title: 'Beginner Guide: How to Use Spreadsheets for Smart Shopping',
    desc: 'Step-by-step tutorial for newcomers. Learn category navigation, product comparison techniques, and how to make your first spreadsheet-assisted purchase with confidence.',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20beginner%20workspace%20scene%20with%20open%20laptop%20showing%20step%20by%20step%20tutorial%20interface%20alongside%20shopping%20reference%20materials%20product%20catalogs%20and%20notepad%20on%20warm%20minimalist%20desk%20natural%20daylight%20clean%20organized%20composition&width=800&height=500&seq=seo-article-05&orientation=landscape',
    link: '/kakobuy-spreadsheet-guide',
  },
  {
    title: 'Best Kakobuy Finds: Top Products From Every Category',
    desc: 'Curated roundup of standout products discovered through the spreadsheet. Sneakers, streetwear, accessories, and hidden gems that shoppers are loving in 2026.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20arrangement%20of%20curated%20fashion%20finds%20featuring%20sneakers%20accessories%20and%20lifestyle%20products%20artfully%20arranged%20on%20light%20cream%20textured%20surface%20with%20soft%20natural%20shadows%20editorial%20product%20photography%20warm%20tones&width=800&height=500&seq=seo-article-06&orientation=landscape',
    link: '/vigorbuy-spreadsheet',
  },
  {
    title: 'Spreadsheet Categories Explained: Find Exactly What You Need',
    desc: 'Deep dive into all 14 product categories. Understand what each category offers, how products are organized, and which sections match your shopping interests.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20grid%20layout%20of%20diverse%20product%20category%20icons%20and%20labels%20displayed%20on%20clean%20modern%20interface%20with%20soft%20neutral%20background%20representing%20fashion%20footwear%20accessories%20and%20lifestyle%20shopping%20sections%20minimal%20aesthetic&width=800&height=500&seq=seo-article-07&orientation=landscape',
    link: '/kakobuy-spreadsheet-guide',
  },
  {
    title: 'Kakobuy vs Vigorbuy: Which Spreadsheet Is Right for You?',
    desc: 'Side-by-side comparison of the two leading spreadsheet platforms. Understand the differences in curation philosophy, category focus, and user experience.',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20layout%20concept%20with%20two%20distinct%20product%20catalog%20views%20side%20by%20side%20on%20clean%20minimalist%20desk%20setup%20showing%20different%20organizational%20styles%20warm%20neutral%20background%20professional%20editorial%20aesthetic%20balanced%20composition&width=800&height=500&seq=seo-article-08&orientation=landscape',
    link: '/vigorbuy-spreadsheet',
  },
  {
    title: '2026 Spreadsheet Shopping Trends: What Is New This Year',
    desc: 'Stay ahead of the curve with the latest spreadsheet shopping trends. New categories, enhanced QC standards, community curation features, and platform updates.',
    image: 'https://readdy.ai/api/search-image?query=Forward%20looking%20modern%20digital%20commerce%20concept%20with%20trend%20forecasting%20dashboard%20on%20sleek%20laptop%20screen%20surrounded%20by%20fashion%20mood%20boards%20color%20swatches%20and%20product%20samples%20on%20bright%20clean%20workspace%20creative%20direction%20photography%20style&width=800&height=500&seq=seo-article-09&orientation=landscape',
    link: '/kakobuy-spreadsheet-guide',
  },
];

export default function SEOArticleGrid() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            Shopping Guides & Resources
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Expert Spreadsheet Shopping Articles
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            Dive into our collection of in-depth guides covering everything from beginner tutorials to advanced product research strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="group bg-background-50 border border-background-200/60 hover:border-accent-200 rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer hover:shadow-lg"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <div
                  className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-500"
                  style={{ backgroundImage: `url('${article.image}')` }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent" />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-accent-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.desc}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-xs font-medium text-accent-600">
                  <span>Read Article</span>
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore All Products on Main Platform
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}